var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50014 10.2889C4.52385 6.44322 7.64871 3.33301 11.5 3.33301H21.5C25.3479 3.33301 28.4706 6.43774 28.4998 10.2788L16.4931 19.1587L4.50014 10.2889ZM4.5 12.7412V21.6663C4.5 25.5323 7.63401 28.6663 11.5 28.6663H21.5C25.366 28.6663 28.5 25.5323 28.5 21.6663V12.7311L16.4931 21.4738L4.5 12.7412Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/mail_fill.1fa43cdb136ccf623a383be2faae374a.svg";
export { ForwardRef as ReactComponent };